import {
  TabStrip as KendoTabStrip,
  TabStripProps as KendoTabStripProps,
  TabStripTab as KendoTabStripTab,
  TabStripSelectEventArguments,
} from '@progress/kendo-react-layout';
import _ from 'lodash';
import { JSX, useState } from 'react';

export interface TabInfo {
  title: string;
  details: JSX.Element;
}

interface TabStripProps {
  tabs: TabInfo[];
}

export default function TabStrip(props: TabStripProps & KendoTabStripProps) {
  const { tabs } = props;
  const [selected, setSelected] = useState<number>(0);
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };
  return (
    <KendoTabStrip {...props} selected={selected} onSelect={handleSelect}>
      {_.map(tabs, (tab, i) => (
        <KendoTabStripTab key={i} title={tab.title}>
          {tab.details}
        </KendoTabStripTab>
      ))}
    </KendoTabStrip>
  );
}
